import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import bgone from '../../assets/images/background/bg-5.png'
import Bgtwo from '../../assets/images/background/bg-6.png'
import menuList from '../../services/content/menuList.json'
import analytics from '../../services/analytics'

/* ── helpers ── */
const findCategory = (name) => menuList.menu.find((c) => c.category === name);

const TAB_CONFIG = [
    {
        label: 'CHEF SPECIALTIES & PLATTERS',
        categories: ["Chef's Specialties", 'Signature Platters (For Sharing)'],
    },
    {
        label: 'BARISTA MENU',
        categories: ['Hot Coffee', 'Iced Coffee', 'Specialty Drinks'],
        limit: 10,
    },
    {
        label: 'APPETIZERS',
        categories: ['Appetizers & Small Bites'],
        limit: 11,
    },
    {
        label: 'RICE & SALADS',
        categories: ['Rice Lovers', 'Salads'],
    },
    {
        label: 'DESSERTS',
        categories: ['Desserts'],
    },
];

const getTabItems = (tab) => {
    const allItems = tab.categories.flatMap((catName) => {
        const cat = findCategory(catName);
        return cat ? cat.items : [];
    });
    const filtered = tab.skip
        ? allItems.filter((item) => !tab.skip.some((s) => item.name.toLowerCase() === s.toLowerCase()))
        : allItems;
    return tab.limit ? filtered.slice(0, tab.limit) : filtered;
};

const formatPrice = (item) => {
    if (item.price_medium != null && item.price_large != null) {
        return `M $${item.price_medium} / L $${item.price_large}`;
    }
    if (item.price === 0 || item.price == null) return 'Market Price';
    return `$${item.price}`;
};

/* ── component ── */
function Menusection() {
    const [activeTab, setActiveTab] = useState(0);

    const renderMenuItems = (items) => (
        <>
            {items.map((item, i) => (
                <div key={i} className="dish-block">
                    <div className="inner-box">
                        <div className="title clearfix">
                            <div className="ttl clearfix">
                                <h5>
                                    <Link to="/menu">
                                        {item.name}
                                        {item.dietary && <span className="s-info">{item.dietary === 'Vegetarian' ? 'VEG' : item.dietary}</span>}
                                    </Link>
                                </h5>
                            </div>
                            <div className="price"><span>{formatPrice(item)}</span></div>
                        </div>
                        {item.description && (
                            <div className="text desc"><Link to="/menu">{item.description}</Link></div>
                        )}
                    </div>
                </div>
            ))}
        </>
    );

    return (
        <>
            <section className="menu-section home-menu-section">
                <div className="left-bg"><img src={bgone} alt="" title="" /></div>
                <div className="right-bg"><img src={Bgtwo} alt="" title="" /></div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle"><span>from our kitchen</span></div>

                        <div className="pattern-image">
                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Delicious Menu</h2>
                    </div>

                    <div className="tabs-box menu-tabs">
                        <div className="buttons">
                            <ul className="tab-buttons clearfix">
                                {TAB_CONFIG.map((tab, index) => (
                                    <li
                                        key={tab.label}
                                        className={`tab-btn ${activeTab === index ? 'active-btn' : ''}`}
                                        onClick={() => { setActiveTab(index); analytics.trackMenuView(tab.label); }}
                                    >
                                        <span>{tab.label}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="tabs-content">
                            {TAB_CONFIG.map((tab, index) => {
                                if (activeTab !== index) return null;
                                const items = getTabItems(tab);
                                const half = Math.ceil(items.length / 2);
                                const leftItems = items.slice(0, half);
                                const rightItems = items.slice(half);
                                return (
                                    <div key={tab.label} className="tab active-tab">
                                        <div className="row clearfix">
                                            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                                                <div className="inner">
                                                    {renderMenuItems(leftItems)}
                                                </div>
                                            </div>
                                            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                                                <div className="inner">
                                                    {renderMenuItems(rightItems)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="open-timing">
                        <div className="hours">Sun–Thu 11 AM – 2 AM &nbsp;|&nbsp; Fri–Sat 11 AM – 3 AM</div>
                        <div className="link-box">
                            <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                <span className="btn-wrap">
                                    <span className="text-one">view full menu</span>
                                    <span className="text-two">view full menu</span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Menusection
